import { render, staticRenderFns } from "./KnowledgeDetail.vue?vue&type=template&id=33fb53ae&scoped=true"
import script from "./KnowledgeDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeDetail.vue?vue&type=style&index=0&id=33fb53ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb53ae",
  null
  
)

export default component.exports